import type { ReactNode } from 'react';

const SIZE_CLASSES = {
  md: 'max-w-md',
  lg: 'max-w-2xl',
} as const;

export function Modal({
  open,
  onClose,
  title,
  children,
  size = 'md',
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  size?: keyof typeof SIZE_CLASSES;
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-manuscript-ink/70 px-4 py-8">
      <div
        className={`font-manuscript flex max-h-full w-full flex-col rounded-3xl bg-paper-100 shadow-xl shadow-manuscript-ink/15 ${SIZE_CLASSES[size]}`}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-manuscript-line p-6">
          <h2 className="font-display text-lg font-semibold text-manuscript-ink">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-1.5 text-manuscript-ink-soft hover:bg-paper-200 hover:text-manuscript-ink"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="overflow-y-auto p-6">{children}</div>
      </div>
    </div>
  );
}
